import { Component, Inject, LOCALE_ID, Renderer2 } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { IdleService } from '@frontend/common/idle';
import { PhAuthService } from '@frontend/common/ph-auth';
import { PhConfigLoaderService } from '@frontend/common/ph-config-loader';
import { Go } from '@frontend/common/ph-router-store';
import { Store } from '@ngrx/store';
import * as Sentry from '@sentry/angular';
import { SetLocaleId } from './actions/app.actions';

@Component({
  selector: 'db-logged-in',
  template: `
    <div><router-outlet></router-outlet></div>
    <frontend-footer></frontend-footer>
  `,
  styles: [
    `
      :host {
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        height: 100%;
        box-sizing: border-box;
        padding: 0px 24px;
        background: #005695;
      }
    `,
  ],
  standalone: false
})
export class LoggedInComponent {
  constructor(
    @Inject(LOCALE_ID) public localeId: string,
    private store: Store<any>,
    private idleSrv: IdleService,
    private renderer: Renderer2,
    private config: PhConfigLoaderService,
    private dialog: MatDialog,
    private phAuthSrv: PhAuthService
  ) {
    this.store.dispatch(new SetLocaleId({ localeId }));
    const timeout = this.config.getConfig('AUTO_REDIRECT_SEC') || 30;
    this.idleSrv.timeout = timeout * 1000;
    this.idleSrv.setupListeners(this.renderer);
    this.idleSrv.idle.subscribe(() => this.onIdle());
    this.phAuthSrv.user$.subscribe((user) => {
      if (user?.sub) {
        Sentry.setUser({ id: user.sub });
      }
    });
  }

  onIdle() {
    this.dialog.closeAll();
    this.store.dispatch(
      new Go({
        path: ['welcome'],
        extras: { queryParamsHandling: 'preserve' },
      })
    );
  }
}
